<div class="message-modal">
    <img alt="" aria-hidden="true" class="header-image" src="/assets/images/alert-octagon.svg">
    <h1 class="title" id="modal-title">{{ title }}</h1>
    <p class="body">{{ text }}</p>
    <div class="action">
        <button (click)="ok()" class="button primary" i18n="Error box@@popup.btn.ok">Ok</button>
    </div>
</div>
